import { render, staticRenderFns } from "./BotManageGeneral.vue?vue&type=template&id=76b43816&"
import script from "./BotManageGeneral.vue?vue&type=script&lang=js&"
export * from "./BotManageGeneral.vue?vue&type=script&lang=js&"
import style0 from "./BotManageGeneral.vue?vue&type=style&index=0&id=76b43816&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports